import React, { useMemo } from "react";
import { useSelector, shallowEqual } from "react-redux";
import { selectMenuStates } from "../../store/reducers/menuSlice";
import { getBlockchainSport } from "../../api/getBlockchainSport";
import { BlockchainSports } from "../../models/blockchainsports/BlockchainSports";
import AddNewBSModal from "../../components/blockchainsports/modals/AddNewBSModal";
import RemoveBSModal from "../../components/blockchainsports/modals/RemoveBSModal";
import EditBSModal from "../../components/blockchainsports/modals/EditBSModal";
import UserList from "../../components/daisy/UserList";
import { getGroupMembers } from "../../api/getGroupMembers";
import { UserWithInvestment } from "../../types/userWithInvestment";

export default function BlockchainSportsAdminPage() {

  

  const [bsData, setBsData] = React.useState<BlockchainSports[]>([]);
  const [loading, setLoading] = React.useState(false);

  const [showAdd, setShowAdd] = React.useState(false);
  const [showEdit, setShowEdit] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);
  const [selected, setSelected] = React.useState<BlockchainSports | null>(null);

  const [groupMembers, setGroupMembers] = React.useState<UserWithInvestment[]>([]);

  const menu = useSelector(selectMenuStates);
  const groupId = menu?.daisyMenu?.group_id;

  const fetchData = React.useCallback(async () => {
    if (!groupId) return;
    setLoading(true);
    try {
      const res = await getBlockchainSport(groupId);
      setBsData(res);

      const users = await getGroupMembers(groupId);
      setGroupMembers(users);
    } finally {
      setLoading(false);
    }
  }, [groupId]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return (
    <div className="m-10">
      <div className="mb-4 flex items-center justify-between">
        <h1 className="text-2xl font-bold">{menu?.daisyMenu?.group_name ?? "Kérlek válassz előbb csoportot az oldalsó sávban."}</h1>
        <button
          onClick={() => setShowAdd(true)}
          className="rounded-lg bg-gray-900 text-white px-4 py-2 disabled:opacity-60"
          disabled={!groupId}
        >
          Új adatok felvétele
        </button>
      </div>

      <div className="overflow-x-auto rounded-lg shadow">
        <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-100">
            <tr>
            <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Azonosító</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">ATLA darabszám</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Csomópont</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Ebből adattárolást végzők</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Érkező jutalom (DIGITAL)</th>
                <th className="px-4 py-2 text-left text-sm font-semibold text-gray-700">Érkező jutalom (RWA)</th>
                <th className="px-4 py-2 text-right text-sm font-semibold text-gray-700">Műveletek</th>
            </tr>
        </thead>

    <tbody className="divide-y divide-gray-200">
    {loading ? (
        <tr>
        <td colSpan={5} className="px-4 py-6 text-center text-sm text-gray-500">
            Betöltés...
        </td>
        </tr>
    ) : bsData && bsData.length === 0 ? (
        <tr>
        <td colSpan={5} className="px-4 py-6 text-center text-sm text-gray-500">
            Nincs adat
        </td>
        </tr>
    ) : (
        bsData.map((item) => {
        const renderRewardsByType = (
            rewards: BlockchainSports["BlockchainSportsReward"],
            rewardType: "DIGITAL" | "RWA"
          ) => {
            const rows = (rewards ?? []).filter((r) => r.rewardType === rewardType);
            if (rows.length === 0) return <span>-</span>;
            return (
              <ul className="space-y-1">
                {rows.map((r) => (
                  <li key={r.id} className="text-sm">
                    <span className="font-medium">{r.instrumentType}</span>: {r.amount ?? 0}
                  </li>
                ))}
              </ul>
            );
          };
          
        return (
            <tr key={item.id} className="hover:bg-gray-50">
            <td className="px-4 py-2 text-lg text-gray-900">
                {item.id ?? "-"}
            </td>
            <td className="px-4 py-2 text-lg text-gray-900">
                {item.quantity ?? "-"}
            </td>
            <td className="px-4 py-2 text-lg text-gray-900">
                {item.node ?? "-"}
            </td>
            <td className="px-4 py-2 text-lg text-gray-900">
                {item.dataStorageNode ?? "-"}
            </td>
            <td className="px-4 py-2 text-lg text-gray-900 align-top">
                {renderRewardsByType(item.BlockchainSportsReward, "DIGITAL")}
            </td>
            <td className="px-4 py-2 text-lg text-gray-900 align-top">
                {renderRewardsByType(item.BlockchainSportsReward, "RWA")}
            </td>

            <td className="px-4 py-2 text-sm text-right">
            <div className="inline-flex items-center gap-2">
                <button
                type="button"
                onClick={() => {
                    setSelected(item);
                    setShowEdit(true);
                }}
                className="rounded-lg border px-3 py-1.5"
                >
                Módosítás
                </button>
                <button
                type="button"
                onClick={() => {
                    setSelected(item);
                    setShowDelete(true);
                }}
                className="rounded-lg border px-3 py-1.5"
                >
                Törlés
                </button>
            </div>
            </td>

            </tr>
        );
        })
    )}
    </tbody>

        </table>
      </div>

      {groupId && (
        <AddNewBSModal
            title="Új Blockchain Sports rekord"
            group_id={groupId}
            showModal={showAdd}
            closeModal={() => setShowAdd(false)}
            handleStateChange={fetchData}
        />
       )}

       {groupId && selected && (
        <React.Fragment>

            <EditBSModal
                title="Meglévő Blockchain Sports rekord törlése"
                id={selected?.id ?? -1}
                record={selected}
                showModal={showEdit}
                closeModal={() => setShowEdit(false)}
                handleStateChange={fetchData} group_id={groupId}            
            />

            <RemoveBSModal
                title="Meglévő Blockchain Sports rekord törlése"
                id={selected?.id ?? -1}
                showModal={showDelete}
                closeModal={() => setShowDelete(false)}
                handleStateChange={fetchData}
            />
        </React.Fragment>

        
            
        )}

        {groupId && (
            <div className="mt-10 mb-4">
            <h2 className="text-xl font-bold mb-4">Csoport tagjai</h2>
            <UserList screenSize={{
                dynamicWidth: 600,
                dynamicHeight: 600
            }} users={groupMembers}/>   
            </div>
        )}
      
    </div>
  );
}
